import { Dispatch } from 'redux';

import { requestHandler } from '../../api';

export const getCreditLineApprovals = async (
  dispatch: Dispatch,
  id: number,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/creditLine/${id}/approval`,
    dispatch,
  });
  if (response) return response.data;
};

export const exportFactoringCreditLine = async (
  dispatch: Dispatch,
  id: number,
  query: string,
): Promise<Blob | undefined> => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/report/pdf/factoring/creditLine/${id}${query ? `?${query}` : ''}`,
    dispatch,
    responseType: 'blob',
  });
  if (response) return response.data;
};

export const getCreditLineByProduct = async (
  dispatch: Dispatch,
  businessIdentifier: string,
  productType: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/creditLine/express/${businessIdentifier}/product/${productType}`,
    dispatch,
  });
  if (response) return response.data;
};

export const postCreditLineExpress = async (dispatch: Dispatch, data: any) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/creditLine/express`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const getAvailableCreditLineProducts = async (
  dispatch: Dispatch,
  businessIdentifier: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/creditLine/availableProducts/${businessIdentifier}`,
    dispatch,
  });
  if (response) return response.data;
};
